import HouseProvisionsSectionHeader from './HouseProvisionsSectionHeader'

export { HouseProvisionsSectionHeader }
